<template>
  <el-dialog
    :visible.sync="dialog"
    width="640px"
    custom-class="message-read"
    :append-to-body="true"
  >
    <div slot="title" class="message-read__head">
      <div class="message-read__subject">{{ ruleForm.subject }}</div>
      <div v-if="ruleForm.sendedBy || sentAt" class="message-read__meta">
        <span v-if="ruleForm.sendedBy">{{ ruleForm.sendedBy }}</span>
        <span v-if="ruleForm.sendedBy && sentAt"> · </span>
        <span v-if="sentAt">Enviada em {{ sentAt }}</span>
      </div>
    </div>
    <div class="message-read__body" v-html="ruleForm.message"></div>
    <span slot="footer">
      <el-button size="small" @click="toggle">Fechar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from "moment";
import "moment/locale/pt-br";

export default {
  data: function () {
    return {
      ruleForm: {
        id: null,
        sendedBy: '',
        subject: '',
        message: "",
        createdAt: "",
      },
      dialog: false,
    };
  },
  computed: {
    sentAt() {
      const raw = this.ruleForm.createdAt;
      if (!raw) {
        return "";
      }
      const parsed = moment(
        raw,
        ["DD/MM/YYYY HH:mm:ss", "DD/MM/YYYY HH:mm", "DD/MM/YYYY", moment.ISO_8601],
        true
      );
      return parsed.isValid() ? parsed.format("DD/MM/YYYY HH:mm") : "";
    },
  },
  methods: {
    open(data) {
      this.ruleForm.id = data.id;
      this.ruleForm.sendedBy = data.userName;
      this.ruleForm.subject = data.subject;
      this.ruleForm.message = data.messageHtml;
      this.ruleForm.createdAt = data.createdAt;
      this.dialog = true;
    },
    toggle() {
      this.ruleForm.id = '';
      this.ruleForm.sendedBy = '';
      this.ruleForm.subject = '';
      this.ruleForm.message = '';
      this.ruleForm.createdAt = '';
      this.dialog = false;
    },
  },
};
</script>

<style>
.message-read {
  border-radius: 8px;
}

.message-read .el-dialog__header {
  padding: 18px 24px 14px;
  border-bottom: 1px solid #f0f2f5;
}

.message-read .el-dialog__body {
  padding: 18px 24px;
}

.message-read__subject {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
  line-height: 1.4;
  padding-right: 24px; /* não colidir com o X de fechar */
}

.message-read__meta {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

.message-read__body {
  font-size: 14px;
  color: #606266;
  line-height: 1.7;
  max-height: 60vh;
  overflow-y: auto;
  word-break: break-word;
}

.message-read__body h1,
.message-read__body h2,
.message-read__body h3 {
  color: #303133;
  margin: 0 0 8px;
  line-height: 1.4;
}

.message-read__body p {
  margin: 0 0 10px;
}

.message-read__body a {
  color: #22418d;
}

.message-read__body img {
  max-width: 100%;
}
</style>
